import React, { Component } from 'react'
import { ACCESS_POINT, ImgSTEERAUTO } from '../../../../../config'
import CmsContent from '../../../../../MiddleWare/CmsContent'
// import FromLibrary from '../../../CMS/CmndlFormLibrary'
import FromdfLibrary from '../../../CMS/dfcarzlibrary'
import Progress from '../../../../../components/Extra/Progress'
import htmlToDraft from 'html-to-draftjs';
import moment from 'moment';
import http from '../../../../../MiddleWare/httpMiddleWare';
import { FormMiddleWare, SingleSelect } from '../../../../../components/Form'
import LoginModal from '../../../../../components/Modal/Modal'
import iconClose from "../../../../../images/CMS/icon-hamburger-close.svg";
//fileupload

import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

registerPlugin(
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
    FilePondPluginImageResize,
    FilePondPluginFileValidateType,
    FilePondPluginFileValidateSize,
    FilePondPluginImageValidateSize
);

export default class Theme5 extends FormMiddleWare {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            btnDisable: false,
            uploadPercentage: 0,
            pageopt: [{ label: "HOME", value: "/" }, { label: "BUYCAR", value: "/buycars" }, { label: "SELLCAR", value: "/sellyourcars" },
            { label: "SERVICES", value: "/Service" },
            { label: "ABOUTUS", value: "/aboutus" },

            ],
            Show: false,
            getlibrarydataImage: this.props.that.getlibrarydataImage,
            uploadPercentage: 0,
            btnDisable: false,
            alertVisible: false,
            alertVisible1: false,
            customerId: localStorage.getItem("userId"),
            AllContent: [{ name: '', link: '', linkname: '', icon: '', description: '', File: null }],
            Maxlength: 4
        }
    }
    async componentWillReceiveProps(props) {
        try {

            if (props) {
                await this.setState({
                    getlibrarydataImage: this.props.that.getlibrarydataImage,
                    contentTitle: this.props.that.contentTitle1,
                    isEdit: this.props.that.isEdit,
                    editId: this.props.that.editid,
                    fileImg: this.props.that.fileImg,
                    fileJson: this.props.that.fileJson,
                    content2: this.props.that.content2,
                    content1: this.props.that.content1,
                    radio: this.props.that.subTitleId == 1 ? true : false,
                    AllContent: this.props.that.sheetContent
                });


            }
        } catch (error) {
            console.log(error)
        }
    }
    async componentDidMount(props) {
        console.log('did update didmount1');
        try {
            if (this.props) {
                await this.setState({
                    getlibrarydataImage: this.props.that.getlibrarydataImage,
                    contentTitle: this.props.that.contentTitle1 ? this.props.that.contentTitle1 : null,
                    isEdit: this.props.that.isEdit,
                    editId: this.props.that.editid ? this.props.that.editid : null,
                    fileImg: this.props.that.fileImg ? this.props.that.fileImg : null,
                    fileJson: this.props.that.fileJson ? this.props.that.fileJson : null,
                    content2: this.props.that.content2 ? this.props.that.content2 : null,
                    content1: this.props.that.content1 ? this.props.that.content1 : null,
                    radio: this.props.that.subTitleId == 1 ? true : false,
                });
                if (this.props.that.sheetContent) {
                    this.setState({
                        AllContent: this.props.that.sheetContent
                    })
                }


            }
        } catch (error) {
            console.log(error)
        }
    }
    contentHeading = [
        {
            Header: "Search By Hint",
            accessor: "hint"
        },
        {
            Header: "image",
            accessor: "label",
            Cell: d => d.original.label ? <img src={ImgSTEERAUTO + d.original.label} onClick={() => window.open(ImgSTEERAUTO + d.original.label)} style={{ objectFit: 'contain', width: 100, height: 50 }} /> : null
        },
        {
            Header: "Select",
            accessor: "edit",
            Cell: d => this.checktest(d)
        }
    ];
    checktest = (id) => {
        return (
            <button
                type="button"
                className="btn btn-info"
                data-dismiss="modal"
                onClick={() => {
                    this.JSON_refill(id.original.label, "File", this.state.Clickindex);
                }
                }
            >
                Select
            </button>
        );
    };
    JSON_refill = (value, Field, index) => {

        let { AllContent } = this.state;
        if (Field == 'link') {
            AllContent[index]['linkname'] = value.value;
        }

        AllContent[index][Field] = value;
        this.setState({ AllContent });

    };
    addMore = (type = null, i) => {
        let { AllContent, Maxlength } = this.state;
        if (type) {
            AllContent.splice(i, 1)
        } else {
            if (Maxlength > AllContent.length) {
                AllContent.push({ name: '', link: '', icon: '', description: '', File: null })
            }
        }
        this.setState({ AllContent })
    }
    submitCategory = async () => {

        const { pageName, customerId, pageSelected, orgfileJson, orgsheetContent } = this.props.that;
        const { AllContent, File, editId, fileJson, contentTitle, content2, content1 } = this.state;
        if (!pageSelected) {
            this.props.these('errorPage', 'Select Page')
            this.ScrollTop()
        }
        else if (!pageName) {
            this.props.these('errorPageName', 'Enter Page name')
            this.ScrollTop()
            return false;
        } else if (this.state.radio && !content1) {
            this.setState({ HeaderErr: 'Enter Header Title' })
            this.ScrollTop()
            return true
        }
        // else if (!contentTitle) {
        //     this.setState({ conTitleErr: 'Enter Content Title' })
        //     this.ScrollTop()
        //     return true
        // }

        try {
            this.props.these('btnDisable', true)
            this.setState({ btnDisable: true, conTitleErr: '' })
            const formData = new FormData();

            if (pageSelected) formData.append("searchTags", pageSelected.label);
            formData.append("name", pageName);
            formData.append("themeId", 5);
            // formData.append("contentTitle1", contentTitle);

            formData.append("show", 0);
            if (this.state.radio) formData.append('subTitleId', 1)

            formData.append('content2', content2)
            if (content1) formData.append('content1', content1)

            formData.append("sheetContent", JSON.stringify(AllContent));
            formData.append("Date", moment().format('YYYY-MM-DD'));
            formData.append("status", "show");
            formData.append("customerId", customerId);
            formData.append("requireLogin", 'no');

            let deletefiles = []



            const id = editId ? editId : 'id'

            const result = await CmsContent.MultiArrayFileUpload('tbl_pages', formData, id)
            if (result) {
                this.setState({
                    contentTitle: '',
                    content2: '',
                    file: null,
                    AllContent: [],
                    btnDisable: false,
                })
                this.props.these('pageSelected', '');
                this.props.these('pageName', '');
                this.props.these('checked', 0);
                this.props.these('errorPageName', '')
                this.props.these('errorPage', '')
                this.props.these('themeSelected', '')
                this.props.these('themeId', '')
                this.props.these('fileImg', null)
                this.props.these('file2Img', null)
                this.props.these('alertVisible', true)
                this.props.these('btnDisable', false)
                this.props.mainfun()
            }

        } catch (error) {
            console.log(error);
            this.setState({ btnDisable: false })
        }
    }
    selectImage = e => {
        this.setState({ file: e.target.files[0] });
        this.setState({ fileName: e.target.files[0].name });
        // if (e) {
        //     this.setState({
        //         file: e.map(fileItem => fileItem.file),
        //         fileName: e.map(fileItem => fileItem.file)
        //     });

        // }
    };
    submit = async e => {
        e.preventDefault();
        const { file, hint } = this.state;
        if (!file) {
            this.setState({ errorFile: "Select File to Upload" });
            return false;
        } else if (!hint) {
            this.setState({ errorFile: "", errorHint: "Enter Searchable hint" });
            return false;
        } else {
            this.setState({ errorFile: "", btnDisable: true });
            let customerId = this.state.customerId;
            const formData = new FormData();
            // if (file) {
            //     file.map((ival) => {
            //         formData.append("file", ival);
            //     })
            // }
            formData.append("file", file)
            formData.append("type", hint);
            formData.append("customerId", customerId);

            try {
                // let Result = await CmsContent.insertImage(formData, "tbl_image");
                let Result = await CmsContent.SteerImage(formData, 'singleInsert')
                if (Result) {
                    let list = this.state.getlibrarydataImage;
                    const id = list[list.length - 1].id + 1;
                    Result.data.value = id
                    Result.data.label = Result.data.file
                    Result.data.hint = Result.data.type
                    list = [Result.data, ...list]
                    this.setState({
                        getlibrarydataImage: list,
                        file: "",
                        errorFile: "",
                        btnDisable: false,
                        alertVisible1: true,
                        fileName: "",
                        hint: "",
                        errorHint: null
                    });
                    //remove success msg after 3 sec
                    setTimeout(() => this.setState({ alertVisible1: false }), 3000);
                }
            } catch (error) { }
        }
    };
    FILEUPLOAD = (e, doc) => {
        if (e) {
            this.setState({
                [doc]: e.map(fileItem => fileItem.file)
            });
        }
    };
    render() {
        let { AllContent, contentTitle, content2, content1, Maxlength } = this.state;

        const { fileImg, editid } = this.props.that;
        return (
            <React.Fragment>
                <div className="row form-group">
                    <div className="col-sm-2" />
                    <div className="col-sm-2">
                        <label htmlFor="position" >Header</label>
                    </div>
                    <div className="col-sm-5">
                        <div className="col-sm-6" >
                            <input type="radio" style={{ margin: "12px" }} name='radio' value={this.state.radio} checked={this.state.radio} onChange={() => this.setState({ radio: true })} /> Yes
                            <input type="radio" style={{ margin: "7px", marginLeft: "15px" }} name='radio' value={!this.state.radio} checked={!this.state.radio} onChange={() => this.setState({ radio: false, content1: '' })} /> No
                        </div>
                    </div>
                </div>
                {this.state.radio &&
                    <>
                        <div className="row form-group">
                            <div className="col-sm-2" />
                            <div className="col-sm-2">
                                <label htmlFor="position" >Header Title</label>
                            </div>
                            <div className="col-sm-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={'Enter Header Title'}
                                    name="content1"
                                    onChange={this.handleUserInput}
                                    value={content1}
                                />
                            </div>
                            <div className="col-sm-3" >
                                <span className="error-show ">
                                    {this.state.HeaderErr}
                                </span>
                            </div>
                        </div>
                        <br />
                        <div className="row form-group">
                            <div className="col-sm-2" />
                            <div className="col-sm-2">
                                <label htmlFor="exampleInputEmail1">
                                    Header Description
                                </label>
                            </div>
                            <div className="col-sm-5">
                                <textarea
                                    type="text"
                                    className="form-control"
                                    id="content2"
                                    style={{ minHeight: "200px" }}
                                    name="content2"
                                    placeholder="Enter Header Description"
                                    value={content2}
                                    onChange={this.handleUserInput}
                                />
                            </div>
                        </div>
                    </>
                }
                <br />
                <div className="d-flex justify-content-center">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => this.submitCategory()}
                        disabled={this.state.btnDisable}
                    >
                        {this.state.btnDisable ? <i class="fa fa-circle-o-notch fa-spin"></i> : null}&nbsp;
                        {this.state.isEdit ? 'Update' : 'Submit'}
                    </button>

                </div>

            </React.Fragment >
        )
    }
}
